import { bootstrapApplication } from '@angular/platform-browser';
import { isDevMode } from '@angular/core';

import { appConfig } from './app/configs/app.config';
import { ShellComponent } from './components/_main/shell/shell.component';

import './app/configs/ag-grid.config';
import { ModuleRegistry, ValidationModule } from 'ag-grid-community';

if (isDevMode()) {
    ModuleRegistry.registerModules([ValidationModule]);
}

bootstrapApplication(ShellComponent, appConfig)
  .catch((err: unknown) => console.error(err));
